import { ApiUrlService } from './api-url.service';

export default angular
  .module('sfMobile.services.api-url', [
    'LocalStorageModule',
    'sfMobile.config.server',
  ])
  .service('apiUrlService', ApiUrlService).name;
